<nerri-public-page [organisationLogo]="(organisation$ | async)?.logo ?? null">
    <section class="flex w-full flex-col items-start gap-16">
        <div class="flex flex-col gap-4">
            <div class="text-5xl font-extrabold text-primary">{{ "features.register.welcome" | translate }}</div>
            <div class="text-xl font-semibold text-primary">{{ "features.root.description" | translate }}</div>
            <div *ngIf="authError$ | async" class="text-red-500">{{ "features.root.auth_error" | translate }}</div>
        </div>
    </section>

    <section class="flex w-full flex-col items-center gap-6">
        <button mat-flat-button class="w-full" color="accent" (click)="clickLogin()">
            {{ "features.root.login" | translate }}
        </button>

        <a class="text-center underline-offset-2 hover:underline" routerLink="register">
            {{ "features.root.register" | translate }}
        </a>
    </section>
</nerri-public-page>
